module.exports = __webpack_public_path__ + "static/media/fg-desk.bd37ae4e.svg";